<template>
    <div class="basket-col basket-order">
        <div class="basket-order-info">
            <div class="basket-order-title">{{ orderStatusText }}</div>
            <div v-if="!newDeferOrder">
              <div class="basket-order-status" :class="[orderStatusClass]"></div>
              <div class="basket-order-timer" v-show="showDeliveryTimer">{{ orderTimer }}</div>
            </div>
            <div class="basket-order-note" v-show="newDeferOrder || waitingPaymentDeferOrder">
              {{ waitingCookingDeferOrderDescription }}
            </div>
            <div class="basket-order-note" v-show="isTakeAwayOrder">
              {{phrases.TEXT_AFTER_SENT_ORDER_PICKUP}}
              <a :href="'tel:' + pizzeria.phone_full">{{ pizzeria.phone_short }}</a>
            </div>
            <div class="basket-order-note" v-show="showClosestDeliveryNote">
              {{phrases.TEXT_AFTER_SENT_ORDER_TIMER_FINISH}}
            </div>
        </div>
        <div class="basket-order-detail">
            <div class="basket-order-detail-title">{{phrases.TEXT_ORDER_DETAIL}}</div>
            <div class="basket-order-list">
                <div class="basket-order-list-item"
                     v-for="(item, index) in order.productItems" :key="(item.isShareItem ? 'free_product_' : '') + item.id">
                    <div class="basket-order-list-item-row">
                        <div class="basket-order-list-item-title">
                          <span class="basket-order-list-item-position">{{ index+1 }}.</span> {{ item.title }}
                        </div>
                    </div>
                    <div class="basket-order-list-item-row">
                        <div class="basket-order-list-item-description">
                            <span class="description" v-if="item.size">{{ item.size }}{{phrases.PRODUCT_PIZZA_DIAMETR_UNIT}} </span>
                            <span class="description" v-if="item.dough">{{ doughTitle(item.dough) }} </span>
                            <span class="description">x {{ item.quantity }}</span>
                        </div>
                        <div class="basket-order-list-item-price" v-if="item.isFree">{{ phrases.TEXT_FREE }}</div>
                        <div class="basket-order-list-item-price" v-else>{{ item.price }}&#8381;</div>
                    </div>
                </div>
            </div>
            <div class="basket-order-detail-total">
                <div class="basket-order-detail-total-sum">{{phrases.FULL_ORDER_SUM}}: {{ order.total.full_sum }}&#8381;</div>
                <div class="bonus" v-show="order.useBonus">
                  -{{ order.bonusValue }} <span class="bonus-text">{{phrases.PROSTO_BONUSES}}</span>
                </div>
                <div class="basket-order-detail-total-sum" v-if="order.total.discount_sum > 0">
                  {{phrases.TEXT_DISCOUNT}}: {{ order.total.discount_sum }}&#8381;
                </div>
                <div class="basket-order-detail-total-sum" v-if="order.total.delivery_sum > 0">
                  {{phrases.LABEL_PAID_DELIVERY}}: {{ order.total.delivery_sum }}&#8381;
                </div>
                <div class="basket-order-detail-total-sum">{{phrases.TEXT_TOTAL}}: {{ orderTotalSum }}&#8381;</div>
            </div>
            <div class="basket-order-info-delivery">
                <div class="user-name">{{ order.user.name}}</div>
                <div class="user-phone">{{ order.user.phone}}</div>
                <div class="user-address" v-show="order.isDelivery">
                    <div class="user-address-title">{{phrases.TEXT_DELIVERY_TO_ADDRESS}}:</div>
                    <div class="user-address-information">
                        <span v-show="order.address.street">{{ order.address.street.title }}, </span>
                        <span v-show="order.address.house">{{phrases.TEXT_HOUSE}} {{ order.address.house }}, </span>
                        <span v-show="order.address.house">{{phrases.TEXT_BUILDING}} {{ order.address.building }}, </span>
                        <span v-show="order.address.entrance">{{phrases.TEXT_ENTRANCE}} {{ order.address.entrance }}, </span>
                        <span v-show="order.address.floor">{{phrases.TEXT_FLOOR}} {{ order.address.floor }}, </span>
                        <span v-show="order.address.flat">{{phrases.TEXT_OFF_APT}} {{ order.address.flat }}</span>
                    </div>
                    <div class="basket-order-defer" v-show="isShowDeferOrderTime">{{phrases.TEXT_PENDING_FOR}}: {{ orderDeliveryRangeTime }} {{ orderDate }}</div>
                </div>
            </div>
            <div class="basket-order-change" v-show="!order.noChange && order.isDelivery && order.paymentType !== 'online' && order.changeValue > 0">
                {{ phrases.TEXT_CHANGE_FROM }} <span class="banknote">{{ order.changeValue }}</span></div>
            <div class="basket-order-info-pickup" v-show="!order.isDelivery">
                <div class="basket-order-info-pickup-pizzeria">{{phrases.BASKET_DELIVERY_TYPE__PICKUP}}</div>
                <div class="basket-order-defer" v-show="isShowDeferOrderTime">{{phrases.TEXT_PENDING_FOR}}: {{ orderTime }} {{ orderDate }}</div>
            </div>
            <div class="user-comment" v-show="order.comment">
                <div class="user-comment-title">{{phrases.TEXT_NOTE}}:</div>
                <div class="user-comment-value">{{ order.comment }}</div>
            </div>
            <div class="error-text" v-for="(error, index) in orderErrors" :key="index">{{error}}</div>

            <div v-if="order.status === 'SEND_ORDER_ERROR'" class="button basket-remove_order login-button"
                 :class="{disabled: processing}" @click="closeOrderAction(order.id)">
              <span v-if="processing">Выполнение запроса</span>
              <span v-else>Закрыть заказ</span>
            </div>

            <div v-show="devMode">
                <div class="button basket-remove_order login-button" :class="{disabled: processing}"
                     @click="changeOrderStatus(order.id)">изменить статус заказа
                </div>
                <div class="button basket-remove_order login-button" :class="{disabled: processing}"
                     @click="checkOrderStatus(order.id, order.payment_id)">проверить статус заказа
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";

    export default {
        name: "Order",
        data: function(){
            return{
                processing: false,
            };
        },
        computed: {
            ...mapGetters('order', {
                order: 'getOrderInfo',
                orderErrors: 'getOrderErrors',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                waitingTime: 'getWaitingOrderTime',
                devMode: 'getIsDevMode',
                pizzeria: 'getPizzeriaInfo'
            }),
            orderStatusText: function () {
              if(this.newDeferOrder){
                if(this.order.number == null){
                  return this.phrases.YOUR_ORDER_HAS_BEEN_ACCEPTED.replace( ' № order_number', "");
                }
                return this.phrases.YOUR_ORDER_HAS_BEEN_ACCEPTED.replace('order_number', this.order.number);
              }
              return this.order.statusText;
            },
            newDeferOrder: function (){
              return this.order.status === this.ORDER_STATUS_DELAY_WAITING_COOKING && this.order.isDeferOrder;
            },
            waitingPaymentDeferOrder: function (){
              return this.order.status === this.ORDER_STATUS_NEW_WAITING_PAYMENT && this.order.isDeferOrder;
            },
            isTakeAwayOrder: function (){
              return !this.order.isDelivery;
            },
            isClosestDeliveryOrder: function (){
              return !this.newDeferOrder && this.order.isDelivery;
            },
            isShowDeferOrderTime: function (){
              return this.order.isDeferOrder;
            },
            orderStatusClass: function () {
                const order = this.order;
                return order.status !== undefined ? order.status.toLowerCase() : '';
            },
            orderTimer: function () {
                const waitingTime = this.waitingTime <= 0 ? 0 : this.waitingTime;
                const minutes = this.addLeadZeroToDatePart(parseInt((waitingTime/60),0));
                const seconds = this.addLeadZeroToDatePart(parseInt((waitingTime % 60),0));
                return [minutes, seconds].join(':');
            },
            orderDate: function (){
              const orderDateDelivery = this.order.dateDelivery;
              const orderFullDate = new Date(Date.parse(orderDateDelivery));
              return [
                  this.addLeadZeroToDatePart(orderFullDate.getDate()),
                  this.addLeadZeroToDatePart(orderFullDate.getMonth()+1),
                orderFullDate.getFullYear()
              ].join('.');
            },
            orderTime: function (){
              const orderDateDelivery = this.order.dateDelivery;
              const orderFullDate = new Date(Date.parse(orderDateDelivery));
              return [
                  this.addLeadZeroToDatePart(orderFullDate.getHours()),
                  this.addLeadZeroToDatePart(orderFullDate.getMinutes())
              ].join(':');
            },
            orderDeliveryRangeTime: function (){
              return this.order.delayTimeFrom + ' - ' + this.order.delayTimeTo;
            },
            waitingCookingDeferOrderDescription: function (){
              if (this.order.isDelivery) {
                return this.phrases.ORDER_WILL_BE_DELIVERED.replace('order_time_from', this.order.delayTimeFrom)
                    .replace('order_time_to', this.order.delayTimeTo)
                    .replace('order_date', this.orderDate);
              } else {
                return this.phrases.ORDER_WILL_BE_READY.replace('order_date', [this.orderTime, this.orderDate].join(" "));
              }
            },
            orderTotalSum: function (){
              return this.order.total.sum - this.order.bonusValue + this.order.total.delivery_sum;
            },
            isNotWaitingPayment: function (){
              return this.order.status !== this.ORDER_STATUS_NEW_WAITING_PAYMENT;
            },
            isDeliveryNotCancelledOrder: function (){
              return this.order.isDelivery && this.order.status !== this.ORDER_STATUS_CANCELLED;
            },
            hasOrderErrors: function () {
              return this.orderErrors.length > 0;
            },
            showDeliveryTimer: function () {
              return this.isDeliveryNotCancelledOrder && !this.hasOrderErrors && this.isNotWaitingPayment;
            },
            showClosestDeliveryNote: function () {
              return this.isDeliveryNotCancelledOrder && this.isClosestDeliveryOrder && !this.hasOrderErrors;
            }
        },
        methods:{
          closeOrderAction: async function (order_id){
            const component = this;
            if(!component.processing) {
              this.processing = true;
              component.sendRequest('close-order', {order_id: order_id, id: order_id}).then(response => {
                component.$store.commit('app/sentCheckOrderRequest', false);
                const data = response.data;
                if (data.status === 'success') {
                  this.closeOrder();
                }
              }).catch(error => {
                console.error('Error', error);
                this.$store.commit("order/addOrderError", error);
              }).finally(() => {
                this.processing = false;
              });
            }
          }
        },
        mixins: [Utils],
    }
</script>

<style scoped>
  .basket-order{
    .error-text{
      margin: 1rem 0;
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
</style>
